import ThemeIcon from '@atlaskit/icon/core/theme';
import * as React from 'react';

export function SvgMoon() {
  return <ThemeIcon label="" testId="ads-refreshed-icon" />;
}
